<template>
    <div>
        <p class="timeline-talks" v-html="message"></p>
        <div v-show="attachment" class="timeline-upload-file">
            <div class="file-section">
                <i class="icon-cloud secondary-color icon-download"></i>
            </div>
            <div class="file-attach">
                <b-button
                    class="btn btn-link"
                    variant="link"
                    @click="downloadFile(attachment)"
                >
                    <span class="btn-text">Download Attachment</span>
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>
import request from '@/utils/request'
import _ from 'lodash'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: ['details'],
    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {}
    },
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        message() {
            if (
                this.details.currentObj &&
                this.details.currentObj.customerData
            ) {
                if (this.details.currentObj.customerData.lastReview) {
                    return (
                        'Submitted KYC Review Status and changed KYC Status to <b>' +
                        _.startCase(
                            this.details.currentObj.customerData.lastReview
                                .status
                        ) +
                        '</b> with the following comment,<br>' +
                        this.details.currentObj.comments
                    )
                }
            }
            return 'Submitted KYC Review'
        },

        attachment() {
            if (this.details && this.details.currentObj.document) {
                return this.details.currentObj.document.fileName
            }
            return ''
        },
    },
    methods: {
        showModal(attachment) {
            this.$bvModal.show('timeline-image-preview-popup')
            this.$store.commit('setItem', attachment)
        },
        forceFileDownload(response, fileName) {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', fileName) //or any other extension
            document.body.appendChild(link)
            link.click()
        }, // End of forceFileDownload() method

        async downloadFile(fileName) {
            let fileUrl = 'customers/' + fileName

            try {
                let response = await request({
                    url: `/files/${fileUrl}`,
                    responseType: 'arraybuffer',
                })
                let fileExtension = response.headers['content-type']
                if (
                    fileExtension == 'image/png' ||
                    fileExtension == 'image/jpg' ||
                    fileExtension == 'image/jpeg'
                ) {
                    this.showModal(fileName)
                } else {
                    this.forceFileDownload(response, fileName)
                }
            } catch (err) {
                console.log('Error occured: ', err)
            }
        },
    },
}
</script>
